<template>
  <div class="content">
    <v-card>
      <v-tabs v-model="currentTabIndex" background-color="#e2007a" dark>
        <v-tab v-for="tab in tabs" :key="tab" :value="tab">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>
    <div v-if="currentTabIndex == 1">
      <md-card class="p-4">
        <div class="font-medium text-xl pb-4">Cabinet</div>
        <div class="font-medium pt-2">LICENCE MS4</div>
        <md-card>
          <div class="md-layout margeTopSearchBar">
            <div class="md-layout-item md-size-50" style="position: relative">
              <md-field style="margin-top: -10px">
                <label>Numéro de licence</label>
                <md-input
                  v-on:keyup.enter="searchLicences"
                  v-model="licenceNuquery"
                ></md-input>
              </md-field>
              <button class="diagCloseButton" @click="clearLicenceNumberSearch()">
                <md-icon>delete</md-icon>
              </button>
            </div>
            <div class="md-layout-item md-size-50" style="position: relative">
              <md-field style="margin-top: -10px">
                <label>Expert ou client</label>
                <md-input
                  v-on:keyup.enter="searchLicences"
                  v-model="licenceRequery"
                ></md-input>
              </md-field>
              <button class="diagCloseButton" @click="clearExpertSearch()">
                <md-icon>delete</md-icon>
              </button>
            </div>
          </div>
          <md-button class="md-prokov researcheButton" @click="searchLicences()">
            Rechercher
          </md-button>
        </md-card>

        <md-card v-if="licenceSearchPerformed" class="mt-4">
          <div class="md-subheading titleTables">
            Licences trouvées
            <span v-if="licenceSearchCountMessage" class="md-caption" style="margin-left: 10px">
              {{ licenceSearchCountMessage }}
            </span>
          </div>
          <md-divider></md-divider>
          <md-card-content>
            <div
              v-if="licenceSearchResults.length > 0"
              class="licence-search-results-scroll"
            >
              <md-table
                v-model="licenceSearchResults"
                table-header-color="prokov"
                @md-selected="onLicenceSelect"
              >
                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                  md-selectable="single"
                >
                  <md-table-cell md-label="Numéro de licence">
                    {{ item.licenceID }}
                    <span v-if="isLicenceDemoRow(item)" class="demo-licence-badge">
                      licence démo
                    </span>
                  </md-table-cell>
                  <md-table-cell md-label="Client">
                    {{ formatLicenceChoiceLabel(item) }}
                  </md-table-cell>
                  <md-table-cell md-label="Expert">{{
                    item.expert || "—"
                  }}</md-table-cell>
                  <md-table-cell md-label="Capacité">{{ item.capacite }}</md-table-cell>
                </md-table-row>
              </md-table>
            </div>
            <div v-else style="text-align: center">
              La recherche ne trouve aucune licence.
            </div>
          </md-card-content>
        </md-card>

        <md-card v-if="selectedLicence" class="mt-4 p-4">
          <div class="font-medium text-xl pb-4">
            Licence sélectionnée
            <span v-if="isLicenceDemoRow(selectedLicence)" class="demo-licence-badge">
              licence démo
            </span>
          </div>
          <div class="grid grid-cols-2 gap-4">
            <md-field>
              <label>Numéro de licence</label>
              <md-input :value="selectedLicenceInfo.licenceNumber" disabled></md-input>
            </md-field>
            <md-field>
              <label>Revendeur</label>
              <md-input :value="selectedLicenceInfo.revendeur" disabled></md-input>
            </md-field>
            <md-field>
              <label>Expert</label>
              <md-input :value="selectedLicenceInfo.expert" disabled></md-input>
            </md-field>
            <md-field>
              <label>Client</label>
              <md-input :value="selectedLicenceInfo.client" disabled></md-input>
            </md-field>
          </div>
          <p
            v-if="selectedLicence.type !== 'M'"
            class="text-red-600 text-sm mt-2"
          >
            Seules les licences MédiStory 4 peuvent être activées pour Eqwo.
          </p>
        </md-card>
         <div class="font-medium pt-4">STRUCTURE</div>
         <div class="flex flex-col">
           <div class="flex flex-row gap-8">
             <md-field class="basis-1/4">
               <label>Identifiant de structure</label>
               <md-input 
                 required 
                 v-model="structure.finessNumber"
                 :disabled="structure.isDemoMode"
               ></md-input>
             </md-field>
             <md-field class="basis-1/4">
               <label>Nom public</label>
               <md-input v-model="structure.publicName"></md-input>
             </md-field>
             <md-field class="basis-1/4">
               <label>Nom légal</label>
               <md-input v-model="structure.legalName"></md-input>
             </md-field>
            </div>
          <div class="flex flex-row gap-8">
            <md-field class="basis-1/4">
              <label>Ville</label>
              <md-input v-model="structure.city"></md-input>
            </md-field>
            <md-field class="basis-1/4">
              <label>Code postal</label>
              <md-input v-model="structure.zipCode"></md-input>
            </md-field>
            <md-field class="basis-1/2">
              <label>Adresse</label>
              <md-input v-model="structure.address"></md-input>
            </md-field>
          </div>
        </div>
        <div class="flex flex-row gap-8">
          <md-field>
            <label>Email</label>
            <md-input v-model="structure.email"></md-input>
          </md-field>
          <md-field>
            <label>Numéro de téléphone</label>
            <md-input v-model="structure.phoneNumber"></md-input>
          </md-field>
        </div>

        <div class="font-medium text-xl pb-4">Contractant</div>

        <div class="flex flex-col">
          <div class="flex flex-row gap-8">
            <md-field>
              <label>Email</label>
              <md-input required v-model="contractor.email"></md-input>
            </md-field>
            <md-field>
              <label>Nom</label>
              <md-input required v-model="contractor.lastName"></md-input>
            </md-field>
            <md-field>
              <label>Prénom</label>
              <md-input required v-model="contractor.firstName"></md-input>
            </md-field>
          </div>
          <div class="flex flex-row gap-8">
            <md-field>
              <label>RPPS</label>
              <md-input v-model="contractor.rpps"></md-input>
            </md-field>
            <md-field>
              <label>Spécialité médicale</label>
              <md-input v-model="contractor.medicalSpeciality"></md-input>
            </md-field>
            <md-field>
              <label>Numéro de téléphone</label>
              <md-input required v-model="contractor.phoneNumber"></md-input>
            </md-field>
          </div>

          <div class="font-medium text-xl pb-4">Abonnement</div>
          <div class="flex flex-col">
            <div class="flex flex-row gap-8">
              <md-field>
                <label>Quantité agendas</label>
                <md-input required v-model="quantity"></md-input>
              </md-field>
              <md-datepicker v-model="activationDate">
                <label>Date d'activation</label>
              </md-datepicker>
              <md-datepicker required v-model="expirationDate">
                <label>Date d'expiration</label>
              </md-datepicker>
            </div>
            <div class="flex flex-row gap-8">
              <md-checkbox v-model="teleconsultationEnabled"
                >Activer la téléconsultation</md-checkbox
              >
            <div class="flex flex-col gap-2" v-if="teleconsultationEnabled">
              <md-field>
                <label>SIREN (9 chiffres)</label>
                <md-input required v-model="siren" maxlength="9"></md-input>
              </md-field>
              <div class="flex flex-row gap-6 items-center">
                <span class="font-medium">Prestataire de paiement *</span>
                <md-radio v-model="paymentProvider" :value="'PAYPLUG'">PAYPLUG</md-radio>
                <md-radio v-model="paymentProvider" :value="'DISPAY'">DISPAY</md-radio>
              </div>
            </div>
          </div>
          <div class="flex flex-col items-center">
            <md-button
              :disabled="
                structure?.finessNumber == null ||
                contractor?.email == null ||
                contractor?.lastName == null ||
                contractor?.firstName == null ||
                contractor?.phoneNumber == null ||
                Number(quantity) == 0 ||
                activationDate == null ||
                expirationDate == null ||
                selectedLicence == null ||
                selectedLicence.type !== 'M' ||
                (teleconsultationEnabled && !isTeleconsultationFormValid)
              "
              class="md-prokov"
              @click="submit()"
              >Valider {{ activationStatus }}</md-button
            >
          </div>
        </div>
        </div>
      </md-card>
    </div>
    <div v-if="currentTabIndex == 0">
      <md-card class="px-4">
        <md-table
          class="eqwo-agendas-table"
          v-model="agendas"
          md-sort="activationDate"
          md-sort-order="asc"
          md-card
        >
          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell
              md-label="Licence MS4 associée"
              md-sort-by="ms4LicenceId"
            >
              {{ item?.ms4LicenceId }}
            </md-table-cell>
            <md-table-cell md-label="Structure ID" md-sort-by="structureId">
              {{ item?.structureId }}
            </md-table-cell>
            <md-table-cell
              md-label="Email contractant"
              md-sort-by="contractorEmail"
            >
              {{ item?.contractorEmail }}
            </md-table-cell>
            <md-table-cell
              md-label="Nom/prénom"
              md-sort-by="contractorLastName"
            >
              {{ formatContractorName(item) }}
            </md-table-cell>
            <md-table-cell md-label="Quantité" md-sort-by="quantity">
              <md-field v-if="item?.licenceId == editedAgenda?.licenceId">
                <label>Quantité agendas</label>
                <md-input v-model="editedAgenda.quantity"></md-input>
              </md-field>
              <div v-else>
                {{ item?.quantity }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Téléconsultation">
              <div v-if="item?.licenceId == editedAgenda?.licenceId" class="flex flex-row gap-2 items-center">
                <md-checkbox
                  v-model="editedAgenda.options.teleconsultation"
                ></md-checkbox>
              </div>
              <div v-else>
                {{ item?.options?.teleconsultation ? "Oui" : "Non" }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="SIREN" md-sort-by="siren">
              <div v-if="item?.licenceId == editedAgenda?.licenceId" class="flex flex-row gap-2 items-center">
                <md-input
                  v-if="editedAgenda.options.teleconsultation"
                  v-model="editedAgenda.options.siren"
                  maxlength="9"
                  placeholder="SIREN"
                  class="siren-edit-input"
                ></md-input>
                <span v-else class="text-gray-400">—</span>
              </div>
              <div v-else>
                {{ maskSiren(item?.options?.siren) }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Prestataire">
              <div v-if="item?.licenceId == editedAgenda?.licenceId" class="flex flex-row gap-2 items-center">
                <template v-if="editedAgenda.options.teleconsultation">
                  <md-radio v-model="editPaymentProvider" :value="'PAYPLUG'">PAYPLUG</md-radio>
                  <md-radio v-model="editPaymentProvider" :value="'DISPAY'">DISPAY</md-radio>
                </template>
                <span v-else class="text-gray-400">—</span>
              </div>
              <div v-else>
                {{ item?.options?.provider || "—" }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Activation" md-sort-by="activationDate">
              {{ new Date(item?.activationDate).toLocaleDateString("fr") }}
            </md-table-cell>
            <md-table-cell md-label="Expiration" md-sort-by="expirationDate">
              <md-datepicker
                v-if="item?.licenceId == editedAgenda?.licenceId"
                v-model="editedAgenda.expirationDate"
              >
                <label>Date d'expiration</label>
              </md-datepicker>
              <div v-else>
                {{
                  item.expirationDate
                    ? new Date(item?.expirationDate).toLocaleDateString("fr")
                    : "Abonné"
                }}
              </div>
            </md-table-cell>
            <md-table-cell md-label="Renouvellement auto" class="eqwo-col-auto-renewal">
              <md-checkbox
                v-model="item.autoRenewalDoctoDispo"
                @change="toggleAutoRenewal(item)"
                :disabled="updatingLicence === item.licenceId"
              ></md-checkbox>
            </md-table-cell>
            <md-table-cell md-label="Invitation" class="eqwo-col-invitation">
              <div class="eqwo-invitation-cell">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      :color="getInvitationIconColor(item.licenceId)"
                      small
                    >
                      {{ getInvitationIcon(item.licenceId) }}
                    </v-icon>
                  </template>
                  <span>{{ getInvitationTooltip(item.licenceId) }}</span>
                </v-tooltip>
                <md-button
                  class="md-icon-button md-dense eqwo-resend-invitation-btn"
                  :disabled="resendingInvitation === item.licenceId"
                  @click="openResendInvitationConfirm(item)"
                >
                  <md-icon>email</md-icon>
                </md-button>
              </div>
            </md-table-cell>
            <md-table-cell>
              <div class="flex flex-row gap-2 items-center h-12">
                <div
                  class="flex flex-row gap-4"
                  v-if="item?.licenceId == editedAgenda?.licenceId"
                >
                  <md-button
                    style="width: 10px !important"
                    @click="onEditCancel()"
                  >
                    <md-icon>close</md-icon>
                  </md-button>
                  <md-button
                    style="width: 10px !important"
                    @click="onEditValidate()"
                  >
                    <md-icon>check</md-icon>
                  </md-button>
                </div>
                <template v-else>
                  <v-btn
                    icon
                    small
                    color="teal"
                    @click="openContractorDetail(item)"
                  >
                    <v-icon dark>mdi-format-list-bulleted-square</v-icon>
                  </v-btn>
                  <md-button
                    style="width: 20px !important"
                    @click="edit(item)"
                  >
                    <md-icon>create</md-icon>
                  </md-button>
                </template>
              </div>
            </md-table-cell>
          </md-table-row>
        </md-table>
      </md-card>
    </div>

    <EqwoFeedbackDialog
      v-model="showEqwoFeedbackDialog"
      :feedback="eqwoFeedback"
    />

    <md-dialog-confirm
      :md-active.sync="resendInvitationConfirmActive"
      md-title="Renvoyer l'invitation Eqwo ?"
      :md-content="resendInvitationConfirmMessage"
      md-confirm-text="Renvoyer"
      md-cancel-text="Annuler"
      @md-confirm="confirmResendInvitation"
    />

    <v-dialog v-model="contractorDetailDialog" width="700">
      <v-card v-if="selectedAgenda">
        <v-card-title class="text-h5 grey lighten-2">
          {{ contractorDetailTitle }}
        </v-card-title>
        <v-card-text>
          <div v-if="agendaDetailsLoading" class="eqwo-detail-loading">
            Chargement des informations Eqwo…
          </div>
          <template v-else>
            <p
              v-if="agendaDetailsError"
              class="eqwo-detail-warning"
            >
              {{ agendaDetailsError }}
            </p>

            <h4>LICENCE EQWO</h4>
            <div class="eqwo-detail-block">
              ID : {{ selectedAgenda.licenceId }}<br />
              Licence MS4 : {{ selectedAgenda.ms4LicenceId }}<br />
              Quantité agendas : {{ selectedAgenda.quantity }}<br />
              Téléconsultation :
              {{ selectedAgenda.options?.teleconsultation ? "Oui" : "Non" }}<br />
              <template v-if="selectedAgenda.options?.teleconsultation">
                SIREN : {{ maskSiren(selectedAgenda.options?.siren) || "—" }}<br />
                Prestataire : {{ selectedAgenda.options?.provider || "—" }}<br />
              </template>
              Activation :
              {{ formatDetailDate(selectedAgenda.activationDate) }}<br />
              Expiration :
              {{
                selectedAgenda.expirationDate
                  ? formatDetailDate(selectedAgenda.expirationDate)
                  : "Abonné"
              }}<br />
              Renouvellement auto :
              {{ selectedAgenda.autoRenewalDoctoDispo ? "Oui" : "Non" }}
            </div>

            <h4 class="eqwo-detail-section">STRUCTURE</h4>
            <div class="eqwo-detail-block">
              Identifiant : {{ agendaDetailsStructure?.structureId || "—" }}<br />
              Nom public : {{ agendaDetailsStructure?.publicName || "—" }}<br />
              Nom légal : {{ agendaDetailsStructure?.legalName || "—" }}<br />
              Adresse : {{ formatStructureAddress(agendaDetailsStructure) }}<br />
              Email : {{ agendaDetailsStructure?.email || "—" }}<br />
              Tél : {{ agendaDetailsStructure?.phoneNumber || "—" }}
            </div>

            <h4 class="eqwo-detail-section">CONTRACTANT</h4>
            <div class="eqwo-detail-block">
              {{ contractorDetailName }}<br />
              Email : {{ agendaDetailsContractor?.email || "—" }}<br />
              Tél : {{ agendaDetailsContractor?.phoneNumber || "—" }}<br />
              RPPS : {{ agendaDetailsContractor?.rpps || "—" }}<br />
              Spécialité : {{ agendaDetailsContractor?.medicalSpeciality || "—" }}<br />
              Invitation envoyée :
              {{
                formatInvitationDate(
                  getContractorInvitationDisplayDate(
                    selectedAgenda?.licenceId,
                    agendaDetailsContractor?.invitedAt
                  )
                )
              }}
            </div>
          </template>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="contractorDetailDialog = false">
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { useStructureIdentifier } from "../composables/useStructureIdentifier";
import toolsFormat from "@/tools/toolsFormat.js";
import EqwoFeedbackDialog from "@/components/EqwoFeedbackDialog.vue";

export default {
  name: "Agenda",
  components: {
    EqwoFeedbackDialog,
  },
  data() {
    return {
      currentTabIndex: 0,
      tabs: ["UTILISATEURS", "ACTIVATION"],
      licenceNuquery: "",
      licenceRequery: "",
      licenceSearchPerformed: false,
      selectedLicence: null,
      structureType: "PS",
      structure: {
        finessNumber: null,
        publicName: "",
        legalName: "",
        address: "",
        zipCode: "",
        city: "",
        email: null,
        phoneNumber: "",
        typeOptions: ["PS", "SCM", "SCP", "SISA", "MSP", "CDS"],
        type: "PS",
        isDemoMode: false,
      },
      contractor: {
        lastName: null,
        firstName: null,
        rpps: null,
        medicalSpeciality: "",
        email: null,
        phoneNumber: null,
        imatAM: 0,
      },
      quantity: 0,
      activationDate: new Date(),
      expirationDate: (() => {
        const date = new Date();
        date.setFullYear(date.getFullYear() + 1);
        return date;
      })(),
      teleconsultationEnabled: false,
      siren: null,
      paymentProvider: null,
      editedAgenda: null,
      editPaymentProvider: null,
      editedExpirationDate: null,
       editedQuantity: null,
       updatingLicence: null,
       showEqwoFeedbackDialog: false,
       eqwoFeedback: {
         type: "success",
         title: "",
         message: "",
         hint: null,
       },
       contractorDetailDialog: false,
       selectedAgenda: null,
       agendaDetailsLoading: false,
       agendaDetailsError: null,
       agendaDetailsStructure: null,
       agendaDetailsContractor: null,
       resendInvitationConfirmActive: false,
       resendInvitationTarget: null,
       resendingInvitation: null,
     };
   },
   mounted() {
     this.$store.dispatch('agenda/getExperts');
     this.loadAgendasWithInvitations();
   },
   setup() {
     const {
       handleLicenceChange,
       isLicenceDemo,
       normalizeLicenceId,
     } = useStructureIdentifier();
     return {
       handleLicenceChange,
       isLicenceDemo,
       normalizeLicenceId,
     };
   },
   computed: {
    activationStatus: {
      get() {
        return this.$store.getters["agenda/getStatus"];
      },
      set(newValue) {},
    },
    experts: {
      get() {
        return this.$store.getters["agenda/getExperts"];
      },
      set(newValue) {},
    },
    licenceSearchResults: {
      get() {
        const res = this.$store.getters["agenda/getMs4LicenceSearch"];
        if (res?.data?.licences?.rows) {
          return res.data.licences.rows;
        }
        return [];
      },
      set() {},
    },
    resendInvitationConfirmMessage() {
      const email = this.resendInvitationTarget?.contractorEmail || "";
      return email
        ? `Un e-mail d'invitation sera renvoyé à ${email}.`
        : "Un e-mail d'invitation sera renvoyé au contractant.";
    },
    invitationStatuses() {
      return this.$store.getters["agenda/getInvitationStatuses"] || {};
    },
    licenceSearchCountMessage() {
      const res = this.$store.getters["agenda/getMs4LicenceSearch"];
      if (!res?.data?.licences) {
        return "";
      }
      const { count, rows } = res.data.licences;
      if (count <= rows.length) {
        return `${rows.length} licence(s) affichée(s).`;
      }
      return `${rows.length} licence(s) affichée(s) sur ${count} — affinez la recherche si besoin.`;
    },
    selectedLicenceInfo() {
      if (!this.selectedLicence) {
        return {
          licenceNumber: "",
          revendeur: "",
          expert: "",
          client: "",
        };
      }
      const parsed = this.parseLicenceCustomer(this.selectedLicence.customer);
      const expert = this.selectedLicence.expert || parsed.expert;
      const client = this.selectedLicence.cabinet || parsed.client;
      const revendeur =
        this.selectedLicence.revendeur ||
        this.experts.find(
          (company) =>
            Number(company.companyID) ===
            Number(this.selectedLicence.companyID)
        )?.name ||
        expert;
      return {
        licenceNumber: this.selectedLicence.licenceID,
        revendeur,
        expert,
        client,
      };
    },
    agendas: {
      get() {
        let list = this.$store.getters["agenda/getAgendas"];
        return list;
      },
      set(newValue) {},
    },
    isSirenValid: {
      get() {
        return this.siren == null || this.siren.length === 9;
      },
      set() {},
    },
    isTeleconsultationFormValid: {
      get() {
        if (!this.teleconsultationEnabled) {
          return true;
        }
        return (
          typeof this.siren === "string" &&
          this.siren.length === 9 &&
          this.isPaymentProviderValid(this.paymentProvider)
        );
      },
      set() {},
    },
    contractorDetailTitle() {
      if (!this.selectedAgenda) {
        return "Contractant";
      }
      const name = this.contractorDetailName;
      return name !== "—" ? name : this.selectedAgenda.contractorEmail || "Contractant";
    },
    contractorDetailName() {
      const contractor = this.agendaDetailsContractor;
      if (contractor) {
        const parts = [contractor.firstName, contractor.lastName].filter(Boolean);
        if (parts.length) {
          return parts.join(" ");
        }
      }
      if (!this.selectedAgenda) {
        return "—";
      }
      const parts = [
        this.selectedAgenda.contractorFirstName,
        this.selectedAgenda.contractorLastName,
      ].filter(Boolean);
      return parts.length ? parts.join(" ") : "—";
    },
  },
  watch: {
    agendas: function (newVal, oldVal) {},
    currentTabIndex: function (newVal, oldVal) {
      this.$store.dispatch("agenda/getAgendas");
    },
    teleconsultationEnabled: function (enabled) {
      if (!enabled) {
        this.siren = null;
        this.paymentProvider = null;
      }
    },
    "editedAgenda.options.teleconsultation": function (enabled) {
      if (!enabled) {
        this.editPaymentProvider = null;
      }
    },
  },
  methods: {
    parseLicenceCustomer(customer) {
      if (!customer || typeof customer !== "string") {
        return { expert: "—", client: "—" };
      }
      const parts = customer.split(" - ");
      if (parts.length >= 2) {
        return {
          expert: parts[0].trim(),
          client: parts.slice(1).join(" - ").trim(),
        };
      }
      return { expert: "—", client: customer.trim() };
    },
    formatLicenceChoiceLabel(item) {
      const cabinet = item.cabinet || this.parseLicenceCustomer(item.customer).client;
      if (!cabinet || cabinet === "—") {
        return item.licenceID;
      }
      return `${cabinet} (licence : ${Number(item.licenceID)})`;
    },
    getLicenceSoftwareType(type) {
      const dict = {
        M: "MédiStory 4",
        E: "ExpressVitale",
        P: "VigiPaiement",
        C: "VigiCompta",
      };
      return dict[type] || type || "";
    },
    formatLicenceDate(date) {
      if (!date) {
        return "";
      }
      return toolsFormat.getDateLong(date);
    },
    async searchLicences() {
      const hasLicenceNumber = this.licenceNuquery.trim().length > 0;
      const hasCustomer = this.licenceRequery.trim().length > 0;
      if (!hasLicenceNumber && !hasCustomer) {
        this.showNotification(
          "error",
          "Veuillez renseigner au moins un critère de recherche"
        );
        return;
      }
      this.licenceSearchPerformed = true;
      this.selectedLicence = null;
      try {
        await this.$store.dispatch("agenda/searchMs4Licences", {
          n: hasLicenceNumber ? this.licenceNuquery.trim() : undefined,
          r: hasCustomer ? this.licenceRequery.trim() : undefined,
          limit: 300,
        });
      } catch (errorInfo) {
        this.showErrorNotification(errorInfo);
      }
    },
    defaultExpirationDate() {
      const date = new Date();
      date.setFullYear(date.getFullYear() + 1);
      return date;
    },
    clearLicenceNumberSearch() {
      this.licenceNuquery = "";
    },
    clearExpertSearch() {
      this.licenceRequery = "";
    },
    isLicenceDemoRow(licence) {
      return this.isLicenceDemo({
        licenceID: this.normalizeLicenceId(licence?.licenceID),
        demo: licence?.demo,
        licences: [
          {
            licenceID: this.normalizeLicenceId(licence?.licenceID),
            demo: licence?.demo,
          },
        ],
      });
    },
    onLicenceSelect(licence) {
      if (!licence) {
        this.selectedLicence = null;
        return;
      }
      this.selectedLicence = licence;
      const licenceId = this.normalizeLicenceId(licence.licenceID);
      const updates = this.handleLicenceChange(
        {
          licenceID: licenceId,
          ms4LicenceId: licenceId,
          demo: licence.demo,
          licences: [{ licenceID: licenceId, demo: licence.demo }],
        },
        this.structure
      );
      this.structure = { ...this.structure, ...updates };
    },
    isPaymentProviderValid(provider) {
      return provider === "PAYPLUG" || provider === "DISPAY";
    },
    edit(value) {
      value.expirationDate = new Date(value.expirationDate);
      const rawOptions = value.options;
      const options =
        typeof rawOptions === "string"
          ? JSON.parse(rawOptions)
          : { ...(rawOptions || {}) };

      this.editedAgenda = { ...value, options: {} };
      this.$set(this.editedAgenda, "options", options);

      if (this.editedAgenda.options.teleconsultation && !this.editedAgenda.options.siren) {
        this.$set(this.editedAgenda.options, "siren", "");
      }

      this.editPaymentProvider = this.isPaymentProviderValid(options.provider)
        ? options.provider
        : null;
    },
    onEditCancel() {
      this.editedAgenda = null;
      this.editPaymentProvider = null;
    },
    async onEditValidate() {
      // Validate SIREN when téléconsultation is enabled
      if (this.editedAgenda.options.teleconsultation) {
        const siren = this.editedAgenda.options.siren;
        if (!siren || siren.length !== 9) {
          this.showNotification("error", "Le SIREN est obligatoire (9 chiffres) lorsque la téléconsultation est activée");
          return;
        }
        if (!this.isPaymentProviderValid(this.editPaymentProvider)) {
          this.showNotification("error", "Le prestataire de paiement (PAYPLUG ou DISPAY) est obligatoire lorsque la téléconsultation est activée");
          return;
        }
      }
      
      const param = {
        licenceId: this.editedAgenda.licenceId,
        quantity: this.editedAgenda.quantity,
        expirationDate: this.editedAgenda.expirationDate,
        options: {
          teleconsultation: this.editedAgenda.options.teleconsultation,
        },
      };
      
      if (this.editedAgenda.options.teleconsultation) {
        param.options.siren = this.editedAgenda.options.siren;
        param.options.provider = this.editPaymentProvider;
      }
      
      try {
        await this.$store.dispatch("agenda/updateAgenda", param);
        this.editedAgenda = null;
        this.openEqwoFeedback({
          type: "success",
          title: "Mise à jour réussie",
          message: "La licence Eqwo a été mise à jour avec succès.",
        });
      } catch (errorInfo) {
        this.showErrorNotification(errorInfo);
      }
    },
    async submit() {
      const options = this.teleconsultationEnabled
        ? {
            teleconsultation: true,
            siren: this.siren,
            provider: this.paymentProvider,
          }
        : {}
      const param = {
        activationDate: this.activationDate,
        expirationDate: this.expirationDate,
        ms4LicenceId: String(Number(this.selectedLicence.licenceID)).padStart(
          6,
          "0"
        ),
        structure: this.structure,
        contractor: this.contractor,
        quantity: this.quantity,
        options,
        teleconsultationEnabled: this.teleconsultationEnabled,
      };
      
      try {
        await this.$store.dispatch("agenda/activateAgenda", param);
        this.selectedLicence = null;
        this.licenceSearchPerformed = false;
        this.licenceNuquery = "";
        this.licenceRequery = "";
        this.expirationDate = this.defaultExpirationDate();
        this.siren = null;
        this.paymentProvider = null;
        this.openEqwoFeedback({
          type: "success",
          title: "Activation réussie",
          message: "La licence Eqwo a été activée avec succès.",
          hint: "Retrouvez le contrat dans l'onglet UTILISATEURS.",
        });
        try {
          await this.$store.dispatch("agenda/getInvitationStatuses");
        } catch (_error) {
          // Ignorer si Eqwo est indisponible juste après l'activation.
        }
      } catch (errorInfo) {
        this.showErrorNotification(errorInfo);
      }
    },
    showNotification(type, message) {
      this.openEqwoFeedback({
        type: type === "success" ? "success" : "error",
        title: type === "success" ? "Succès" : "Erreur",
        message,
      });
    },
    openEqwoFeedback({ type, title, message, hint = null }) {
      this.eqwoFeedback = { type, title, message, hint };
      this.showEqwoFeedbackDialog = true;
    },
    /**
     * Masque un SIREN pour affichage (RGPD) : conserve uniquement les 3 derniers chiffres
     * @param {string|null|undefined} siren
     * @returns {string} "***789" ou "" si pas de siren
     */
    maskSiren(siren) {
      if (!siren || typeof siren !== "string" || siren.length < 3) {
        return "";
      }
      return `***${siren.slice(-3)}`;
    },
    formatDetailDate(date) {
      if (!date) {
        return "—";
      }
      return new Date(date).toLocaleDateString("fr");
    },
    formatInvitationDate(date) {
      if (!date) {
        return "—";
      }
      return new Date(date).toLocaleString("fr-FR", {
        timeZone: "Europe/Paris",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      });
    },
    getContractorInvitationDisplayDate(licenceId, invitedAt) {
      const status = licenceId ? this.getInvitationStatus(licenceId) : null;
      return status?.sentAt || status?.invitedAt || invitedAt || null;
    },
    async loadAgendasWithInvitations() {
      await this.$store.dispatch("agenda/getAgendas");
      try {
        await this.$store.dispatch("agenda/getInvitationStatuses");
      } catch (_error) {
        // Les statuts d'invitation restent optionnels si Eqwo est indisponible.
      }
    },
    getInvitationStatus(licenceId) {
      return this.invitationStatuses[licenceId] || null;
    },
    getEffectiveInvitationDate(licenceId) {
      const status = this.getInvitationStatus(licenceId);
      return status?.sentAt || status?.invitedAt || null;
    },
    getInvitationIcon(licenceId) {
      return this.getEffectiveInvitationDate(licenceId)
        ? "mdi-email-check"
        : "mdi-email-off-outline";
    },
    getInvitationIconColor(licenceId) {
      return this.getEffectiveInvitationDate(licenceId) ? "green" : "grey";
    },
    getInvitationTooltip(licenceId) {
      const date = this.getEffectiveInvitationDate(licenceId);
      if (!date) {
        return "Aucune invitation enregistrée";
      }
      return `Invitation envoyée le ${this.formatInvitationDate(date)}`;
    },
    openResendInvitationConfirm(item) {
      this.resendInvitationTarget = item;
      this.resendInvitationConfirmActive = true;
    },
    async confirmResendInvitation() {
      const item = this.resendInvitationTarget;
      if (!item?.licenceId) {
        return;
      }
      this.resendingInvitation = item.licenceId;
      try {
        const result = await this.$store.dispatch(
          "agenda/resendInvitation",
          item.licenceId
        );
        this.$store.commit("agenda/UPDATE_INVITATION_STATUS", {
          licenceId: item.licenceId,
          invitedAt: result?.invitedAt || result?.sentAt || null,
          sentAt: result?.sentAt || null,
        });
        this.$store.dispatch("notification/sendNotification", {
          message: "Invitation renvoyée",
          icon: "email",
          type: "success",
        });
      } catch (errorInfo) {
        this.showErrorNotification(errorInfo);
      } finally {
        this.resendingInvitation = null;
        this.resendInvitationTarget = null;
      }
    },
    formatContractorName(item) {
      const parts = [item?.contractorFirstName, item?.contractorLastName].filter(
        Boolean
      );
      return parts.length ? parts.join(" ") : "—";
    },
    formatStructureAddress(item) {
      if (!item) {
        return "—";
      }
      const parts = [
        item.address,
        [item.zipCode, item.city].filter(Boolean).join(" "),
      ].filter(Boolean);
      return parts.length ? parts.join(", ") : "—";
    },
    async openContractorDetail(item) {
      const rawOptions = item.options;
      const options =
        typeof rawOptions === "string"
          ? JSON.parse(rawOptions)
          : { ...(rawOptions || {}) };
      this.selectedAgenda = { ...item, options };
      this.agendaDetailsStructure = null;
      this.agendaDetailsContractor = null;
      this.agendaDetailsError = null;
      this.agendaDetailsLoading = true;
      this.contractorDetailDialog = true;

      try {
        const details = await this.$store.dispatch(
          "agenda/getAgendaDetails",
          item.licenceId
        );
        this.agendaDetailsStructure = details?.structure || null;
        this.agendaDetailsContractor = details?.contractor || null;
        if (details?.partialErrors?.length) {
          this.agendaDetailsError =
            "Certaines informations Eqwo n'ont pas pu être récupérées. Les données affichées peuvent être incomplètes.";
        }
      } catch (errorInfo) {
        this.agendaDetailsError =
          errorInfo?.message ||
          "Impossible de récupérer les informations Eqwo pour ce contractant.";
        this.agendaDetailsContractor = {
          firstName: item.contractorFirstName,
          lastName: item.contractorLastName,
          email: item.contractorEmail,
          rpps: item.contractorRpps,
        };
        this.agendaDetailsStructure = {
          structureId: item.structureId,
        };
      } finally {
        this.agendaDetailsLoading = false;
      }
    },
    showErrorNotification(errorInfo) {
      const errorTypeLabels = {
        EQWO_API_ERROR: "Erreur Eqwo",
        LICENCE_NOT_FOUND: "Licence introuvable",
        VALIDATION_ERROR: "Erreur de validation",
        MISSING_API_KEY: "Configuration serveur",
        NETWORK_ERROR: "Erreur réseau",
        AUTHENTICATION_ERROR: "Erreur d'authentification Eqwo",
        INTERNAL_ERROR: "Erreur interne",
        UNKNOWN_ERROR: "Erreur",
      };

      const hints = {
        MISSING_API_KEY:
          "La clé API Eqwo PRP doit être configurée dans .env.prod.local sur le serveur admin.",
        AUTHENTICATION_ERROR:
          "Vérifiez la clé API Eqwo sur le serveur. Ce message ne signifie pas que votre session admin a expiré.",
      };

      const title = errorTypeLabels[errorInfo.type] || "Erreur";
      let hint = hints[errorInfo.type] || null;

      if (
        errorInfo.type === "EQWO_API_ERROR" &&
        (errorInfo.eqwoStatus === 409 ||
          errorInfo.message?.includes("already exists"))
      ) {
        hint =
          "Un contrat Eqwo existe déjà pour cette structure et cet email. Consultez l'onglet UTILISATEURS pour le modifier.";
      }

      this.openEqwoFeedback({
        type: "error",
        title,
        message: errorInfo.message || "Une erreur inattendue s'est produite.",
        hint,
      });
    },
    async toggleAutoRenewal(item) {
      try {
        this.updatingLicence = item.licenceId;
        await this.$store.dispatch("agenda/toggleDoctoDispoAutoRenewal", {
          licenceId: item.licenceId,
          autoRenewalDoctoDispo: item.autoRenewalDoctoDispo,
        });
      } catch (error) {
        // Revert the checkbox on error
        item.autoRenewalDoctoDispo = !item.autoRenewalDoctoDispo;
        throw new Error(
          "Erreur lors de la mise à jour du renouvellement automatique:",
          error
        );
      } finally {
        this.updatingLicence = null;
      }
    },
  },
};
</script>

<style lang="scss">
.titleTables {
  margin-top: 16px !important;
  margin-left: 20px !important;
  margin-bottom: 10px !important;
}

.licence-search-results-scroll {
  max-height: 320px;
  overflow-y: auto;
}

.diagCloseButton {
  position: absolute !important;
  top: 5px;
  right: 5px;
  border-style: none;
  background-color: white;
  border-color: white;
  cursor: pointer;
}

.demo-licence-badge {
  font-size: 0.7em;
  color: #2e7d32;
  margin-left: 6px;
}

.eqwo-detail-block {
  color: #1565c0;
  margin-left: 10px;
  margin-top: 10px;
}

.eqwo-detail-section {
  margin-top: 20px;
}

.eqwo-detail-loading {
  padding: 24px 0;
  text-align: center;
  color: #666;
}

.eqwo-detail-warning {
  color: #c62828;
  font-size: 13px;
  margin-bottom: 12px;
}

.eqwo-agendas-table :deep(.md-table-head tr th:nth-child(11)),
.eqwo-agendas-table :deep(.md-table-content tr td:nth-child(11)) {
  width: 72px;
  max-width: 72px;
  min-width: 72px;
  text-align: center;
  padding-left: 4px !important;
  padding-right: 4px !important;
  white-space: normal;
  line-height: 1.2;
  font-size: 11px;
}

.eqwo-col-auto-renewal {
  display: flex;
  justify-content: center;
}

.eqwo-col-invitation {
  min-width: 88px;
}

.eqwo-invitation-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
}

.eqwo-resend-invitation-btn {
  min-width: 32px !important;
  width: 32px !important;
  height: 32px !important;
  margin: 0 !important;
}
</style>
